// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__q7sFW","productName":"Table_productName__1V100"};